import store from '../mainVuex';

const isOpenRoute = route => {

  var openRouteList = [
    "/auth",
    "/forgetPassword",
    "/changePassword"
  ];

  return openRouteList.indexOf(route.path) > -1;
};

const isLogged = () => {
  if (!store.getters.isLogged) {
    store.dispatch('refreshAuthUser')
  }
  return store.getters.isLogged
};

const passwordExpired = () => {
  return store.getters.passwordExpired;
};

export default(to, from, next) => {
  if (!isLogged() && !isOpenRoute(to)) {
    next('/auth');
  } else if (isLogged() && isOpenRoute(to)) {
    next('/');
  } else {

    let role = to.meta.role;

    if(passwordExpired() && (to.path !== '/user/profile')) {
      next('/user/profile');
    } else {

      if (!role) {
        if (to.name === null) {
          next('/businessArea');
        } else {
          next();
        }
      } else {

        store.dispatch('userHasRole', role)
          .then(response => {
            if (response) {
              next();
            } else {
              next('/');
            }
          })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/beforeEach.js